var map = {
	"./Bob.png": 11874,
	"./Contact Us.png": 7677,
	"./Contact Us.svg": 81740,
	"./Kotak 811.png": 74882,
	"./Loan.png": 42461,
	"./My Recharges & Bills.png": 68430,
	"./Paytm.png": 1225,
	"./Privacy Policy.png": 83578,
	"./Privacy Policy.svg": 12674,
	"./Profile.png": 57603,
	"./Profile.svg": 51634,
	"./Referrals.png": 40456,
	"./Referrals.svg": 31567,
	"./Samco.png": 30050,
	"./Signout.png": 68080,
	"./Signout.svg": 29075,
	"./Simply Save.png": 25203,
	"./Standard Chartered.png": 23880,
	"./Terms and Conditions.png": 6846,
	"./Terms and Conditions.svg": 95784,
	"./Tide.png": 17989,
	"./UPI2a.png": 31388,
	"./Upstox.png": 21224,
	"./Visiting Card.png": 32116,
	"./Visiting Card.svg": 98747,
	"./app_download.png": 11206,
	"./approval.png": 72302,
	"./approved.png": 12566,
	"./approved_leads.png": 22444,
	"./approved_new.png": 84333,
	"./aryoright.png": 44709,
	"./bajajsecurities.png": 16326,
	"./bank.png": 61224,
	"./bank.svg": 30483,
	"./bl.png": 57707,
	"./bnpl.png": 57208,
	"./bnpl_new.png": 32390,
	"./business-account.png": 49439,
	"./call.png": 50366,
	"./cc.png": 38800,
	"./cc_new.png": 60686,
	"./circled_right.png": 72333,
	"./close_icon.png": 25443,
	"./crypto.png": 51520,
	"./current_acc_logo.jpg": 54392,
	"./current_acc_logo.png": 26025,
	"./demat.png": 18450,
	"./demat_new.png": 50440,
	"./download_icon.png": 75418,
	"./download_lead.png": 91764,
	"./download_lead_new.png": 9734,
	"./earning.png": 61446,
	"./earning.svg": 88143,
	"./earning_new.png": 61372,
	"./electricity_bill_new.png": 1575,
	"./errorcloud.png": 98578,
	"./exclamation_red.png": 43238,
	"./facebook_blue.png": 64453,
	"./filter.png": 57675,
	"./filter_icon.png": 44616,
	"./filter_icon_new.png": 30225,
	"./filter_logo.png": 80115,
	"./home_black.png": 19310,
	"./home_logo.png": 39044,
	"./il.png": 84165,
	"./inprocess.png": 6119,
	"./inprogress.png": 7916,
	"./instantloan_new.png": 69450,
	"./investment_new.png": 45163,
	"./kyc.svg": 64265,
	"./kyc_1.png": 93770,
	"./leads.png": 90311,
	"./leads_black.png": 20433,
	"./leads_logo.png": 64302,
	"./left-arrow-2.png": 29829,
	"./left-arrow.png": 72484,
	"./loan_new.png": 30906,
	"./loans.png": 73396,
	"./logout.png": 63408,
	"./manager.png": 17283,
	"./no_leads.png": 42967,
	"./ok.png": 47,
	"./otp.png": 54260,
	"./otp1.png": 26548,
	"./owner.png": 88594,
	"./pending_earning_new.png": 46269,
	"./person.png": 11100,
	"./pl.png": 80607,
	"./plus_icon.png": 13572,
	"./postpaid_new.png": 20224,
	"./prepaid_new.png": 75390,
	"./profile-plain-2.png": 78110,
	"./profile-plain.png": 11503,
	"./profile_black.png": 82643,
	"./profile_image.png": 66669,
	"./profile_logo.png": 89940,
	"./refer2.png": 13680,
	"./refer2b.png": 17674,
	"./reject.png": 52679,
	"./revenue_new.png": 69702,
	"./right.png": 63495,
	"./rightArrow.png": 28599,
	"./rupee_blue.png": 42847,
	"./sad.png": 32109,
	"./sasonline.png": 51998,
	"./saving.png": 59863,
	"./savings.jpeg": 68953,
	"./savings.jpg": 74212,
	"./savings.png": 67905,
	"./savings_acc_new.png": 1905,
	"./search.png": 93105,
	"./share_1.png": 28128,
	"./signup.png": 68261,
	"./simpllogo.png": 6859,
	"./sortdown.png": 83371,
	"./stock11.png": 841,
	"./tag.png": 39522,
	"./team.png": 45858,
	"./team.svg": 63359,
	"./team1a.png": 72529,
	"./teamsvector.png": 4030,
	"./telegram_blue.png": 62726,
	"./total.png": 71721,
	"./total_leads_new.png": 47190,
	"./updateprofile.png": 89683,
	"./user.png": 41198,
	"./view_all.png": 10968,
	"./watsapp.png": 52762,
	"./web.png": 90674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84480;